import axios from 'axios';
import moment from 'moment';

export interface AlertsExportResponse {
  content: Blob;
  fileName: string;
}

function extractFileName(contentDisposition?: string): string {
  if (!contentDisposition) {
    return 'alerts-export.zip';
  }

  const utf8FileNameMatch = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8FileNameMatch?.[1]) {
    return decodeURIComponent(utf8FileNameMatch[1]);
  }

  const fileNameMatch = contentDisposition.match(/filename="?([^"]+)"?/i);
  if (fileNameMatch?.[1]) {
    return fileNameMatch[1];
  }

  return 'alerts-export.zip';
}

async function getAlertsExport(
  locationId: number,
  from?: Date,
  to?: Date,
  detectionType?: number
): Promise<AlertsExportResponse> {
  const token = JSON.parse(localStorage.getItem('user')!);
  const authorization = `Bearer ${token.token}`;

  const response = await axios({
    method: 'get',
    url: 'api/v1/programmability/get-alerts-export',
    baseURL: process.env.REACT_APP_API_BUILD_URL,
    headers: {
      'Content-Type': 'Application/json',
      Authorization: authorization,
    },
    responseType: 'blob',
    params: {
      LocationId: locationId,
      From: from ? moment(from).format('YYYY-MM-DDTHH:mm:ss') : undefined,
      To: to ? moment(to).format('YYYY-MM-DDTHH:mm:ss') : undefined,
      DetectionType: detectionType,
    },
  });

  return {
    content: response.data,
    fileName: extractFileName(response.headers['content-disposition']),
  };
}

export default getAlertsExport;
